import { FC, useRef, useState } from 'react';
import { useWindowDimensions, Platform } from 'react-native';
import { View, Image, TouchableOpacity } from 'react-native';
import { Text } from '../../../components/Text';
import { useSelector } from 'react-redux';
import { STYLE_VARS } from '../../../constants/style-vars';
import { RootState } from '../../../services/redux/store';
import { myAccountStyled as styled } from '../styled';
import { useIsDesktop } from '../../../hooks/useIsDeskTop';
import { Asset, launchImageLibrary } from 'react-native-image-picker';
import { Alert } from 'react-native';
import { FONTS } from '../../../constants';
import { IS_WEB } from '../../../constants/platform';

export const User: FC = () => {
  const [imagePath, setImagePath] = useState<any | Asset[]>();
  const inputPhotoRef = useRef<any>(null);
  const { info } = useSelector((redux: RootState) => redux.authReducer);

  return (
    <View style={styled.userInfoWrapper}>
      <View
        style={{
          justifyContent: 'center',
          alignItems: 'center',
          marginBottom: IS_WEB ? 20 : 10,
          flex: 1,
        }}
      >
        <Image
          source={imagePath
            ? (IS_WEB
              ? { uri: imagePath }
              : { uri: imagePath[0].uri }) 
            : (info?.avatar
              ? { uri: info?.avatar }
              : require('../../../assets/avatar.png'))
          }
          style={{
            borderRadius: 120,
            width: 120,
            height: 120,
            resizeMode: 'cover',
          }}
        />
      </View>
      <View
        style={{
          flex: 1,
        }}
      >
        <Text style={styled.userInfoText}>
          { (info?.display_name && info.display_name.length > 0)
            ? (info.display_name.toUpperCase())
            : info?.user_login.toUpperCase()
          }
        </Text>
        <Text
          style={[
            styled.userInfoText,
            {
              fontSize: 22,
            },
          ]}
        >
          #{info?.mbnum}
        </Text>
      </View>
      <View
        style={{
          alignSelf: 'center',
        }}
      >
        <Text
          style={{
            textAlign: 'center',
            fontFamily: FONTS.IowanOldStyleBTRoman,
            fontSize: 18,
            paddingHorizontal: 10,
            paddingVertical: 5,
            color: '#ffffff',
            backgroundColor: STYLE_VARS.kccBgGreen,
            borderRadius: 6,
            textTransform: 'uppercase',
          }}
        >
          {info?.member_type}
        </Text>
      </View>
    </View>
  );
};
